import React from "react";
import { useI18n } from "../../i18n/I18nProvider";

const ProofFrame = () => (
  <svg viewBox="0 0 64 80" aria-hidden="true" className="h-16 w-12 shrink-0">
    <rect x="6" y="4" width="52" height="72" rx="10" fill="#FFFFFF" stroke="#5B4A9C" strokeWidth="4" />
    <rect x="14" y="16" width="36" height="40" rx="6" fill="#EDE8FF" />
    <path d="M22 44 L30 28 L38 38 L44 32 L50 44 Z" fill="#A9D4FF" />
    <circle cx="32" cy="64" r="3" fill="#5B4A9C" />
  </svg>
);

const DeskVector = () => {
  const { t } = useI18n();
  const nav = t("rows.desk.nav");

  return (
    <div className="relative overflow-hidden rounded-card border border-hairline bg-paper text-ink shadow-card">
      <div className="flex items-center gap-1.5 border-b border-hairline px-3 py-2">
        <span className="h-2 w-2 rounded-full bg-rose" />
        <span className="h-2 w-2 rounded-full bg-sun" />
        <span className="h-2 w-2 rounded-full bg-mint" />
        <p className="ml-2 truncate text-caption text-mid-gray">{t("rows.desk.kicker")}</p>
      </div>
      <div className="flex flex-col sm:grid sm:grid-cols-[6.75rem_minmax(0,1fr)]">
        <ul className="m-0 flex gap-1 overflow-x-auto border-b border-hairline bg-canvas p-2 sm:flex-col sm:overflow-visible sm:border-b-0 sm:border-r">
          {nav.map((item, index) => (
            <li
              key={item}
              className={`list-none shrink-0 rounded-nested px-2 py-1.5 text-caption sm:shrink sm:truncate ${
                index === 0 ? "bg-lilac font-semibold text-[#241c3e]" : "text-mid-gray"
              }`}
            >
              {item}
            </li>
          ))}
        </ul>
        <div className="flex min-w-0 flex-col gap-2 p-3">
          <div className="rounded-nested border border-hairline bg-canvas p-2.5">
            <div className="flex items-start justify-between gap-2">
              <div className="min-w-0">
                <p className="truncate text-caption font-semibold text-ink sm:text-body">
                  {t("rows.desk.campaign")}
                </p>
                <p className="mt-0.5 text-caption text-mid-gray">{t("rows.desk.publisher")}</p>
              </div>
              <span className="shrink-0 rounded-pill bg-lilac px-2 py-0.5 text-caption text-[#241c3e]">
                {t("rows.desk.status")}
              </span>
            </div>
            <p className="mt-2 text-caption text-mid-gray">{t("rows.calendar.detailWhen")}</p>
            <div className="mt-1.5 grid grid-cols-3 gap-1.5">
              <div className="min-w-0 rounded-nested bg-lilac px-1.5 py-2">
                <p className="text-caption font-semibold leading-tight text-[#241c3e]">
                  {t("rows.calendar.detailTitle")}
                </p>
              </div>
              <div className="min-h-[2.5rem] rounded-nested border border-dashed border-hairline" />
              <div className="min-h-[2.5rem] rounded-nested border border-dashed border-hairline" />
            </div>
          </div>
          <div className="flex items-center gap-2 rounded-nested border border-hairline bg-canvas p-2.5">
            <ProofFrame />
            <div className="min-w-0">
              <p className="text-caption font-medium text-accent">{t("rows.desk.report")}</p>
              <p className="mt-0.5 text-caption text-ink">{t("rows.desk.reportBody")}</p>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-1.5">
            <div className="min-w-0 rounded-nested bg-canvas p-2">
              <p className="truncate text-caption text-mid-gray">{t("rows.desk.credit")}</p>
              <p className="mt-0.5 truncate text-caption font-semibold text-ink">{t("rows.desk.creditValue")}</p>
            </div>
            <div className="min-w-0 rounded-nested bg-canvas p-2">
              <p className="truncate text-caption text-mid-gray">{t("rows.desk.transaction")}</p>
              <p className="mt-0.5 text-caption text-ink">{t("rows.desk.transactionBody")}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeskVector;
